import NAME from "./constants";

export const getLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getPayrollTypes = store => store[NAME].payrollTypes;